<template>

    <div>
        <transition name="modal">
            <v-modal-add v-if="modal === 'add'" />
            <v-modal-apply v-if="modal === 'apply'" />
            <v-modal-copy v-if="modal === 'copy'" />
            <v-modal-font v-if="modal === 'font'" />
            <v-modal-link v-if="modal === 'link'" />
            <v-modal-remove v-if="modal === 'remove'" />
            <v-modal-template v-if="modal === 'template'" />
        </transition>
        <transition name="dim">
            <div v-if="modal" class="modal-backdrop" @click="dismiss"></div>
        </transition>
    </div>

</template>

<style scoped lang="scss">

    .modal-backdrop {
        background: rgba(0,0,0,0.7);
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 1000;
    }

</style>

<script>

import ModalAdd from './modals/ModalAdd';
import ModalApply from './modals/ModalApply';
import ModalCopy from './modals/ModalCopy';
import ModalFont from './modals/ModalFont';
import ModalLink from './modals/ModalLink';
import ModalRemove from './modals/ModalRemove';
import ModalTemplate from './modals/ModalTemplate';

export default {

    components: {
        'v-modal-add': ModalAdd,
        'v-modal-apply': ModalApply,
        'v-modal-copy': ModalCopy,
        'v-modal-font': ModalFont,
        'v-modal-link': ModalLink,
        'v-modal-remove': ModalRemove,
        'v-modal-template': ModalTemplate,
    },

    computed: {

        modal() {
            return this.$store.getters['builder/selectedModal'];
        },

    },

    methods: {

        dismiss() {
            this.$store.commit('builder/setSelectedModal', null);
        },

    },

}

</script>